/* Front-only: ativa o acordeão no site (fora do editor) */
(function () {
  // Evita rodar no editor/admin
  if (typeof document !== 'undefined') {
    const b = document.body;
    if (b && (b.classList.contains('block-editor-page') || b.classList.contains('wp-admin'))) {
      return;
    }
  }

  // Logs opcionais: window.CV_IMGACC_DEBUG = true
  const DEBUG = (() => { try { return !!window.CV_IMGACC_DEBUG; } catch(_) { return false; } })();
  const log = (...a) => { if (DEBUG && window.console) console.log('[CV IMGACC]', ...a); };

  const setActiveFor = (items, idx) => {
    const i = Math.max(0, Math.min(idx, items.length - 1));
    items.forEach((el, k) => el.classList.toggle('is-active', k === i));
  };

  function recalcActiveWidthPx(wrap) {
    if (!wrap) return;
    try {
      const styles = getComputedStyle(wrap);
      const aRaw = styles.getPropertyValue('--acc-active').trim();
      const m = aRaw.match(/-?\d+(\.\d+)?/);
      const aPct = m ? parseFloat(m[0]) : 80;
      const W = wrap.clientWidth;
      const aw = Math.max(0, Math.round(W * (aPct / 100)));
      wrap.style.setProperty('--acc-aw', `${aw}px`);
      log('recalc --acc-aw:', aw, 'px (W=', W, 'a%=', aPct, ')');
    } catch (e) {
      log('erro recalcActiveWidthPx:', e);
    }
  }

  function init(root) {
    if (!root || root.__cvImgAcc) return;
    root.__cvImgAcc = true;

    const wrap = root.querySelector('.cv-imgacc');
    if (!wrap) return;

    // Estado inicial
    const mode = root.getAttribute('data-mode') || 'hover';
    const initial = parseInt(root.getAttribute('data-initial') || '0', 10) || 0;
    const items = Array.from(wrap.querySelectorAll('.cv-imgacc__item'));
    if (!items.length) return;

    setActiveFor(items, initial);
    recalcActiveWidthPx(wrap);

    // Listeners de interação
    items.forEach((el, idx) => {
      const hasLink = !!el.querySelector('.cv-imgacc__link');

      if (mode === 'hover') {
        const onEnter = () => setActiveFor(items, idx);
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('touchstart', onEnter, { passive: true });
        return;
      }

      if (mode === 'click') {
        if (!hasLink) {
          el.setAttribute('tabindex', '0');
          el.addEventListener('click', () => setActiveFor(items, idx));
          el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setActiveFor(items, idx);
            }
          });
        }
      }
    });

    // Recalcula on resize
    const ro = new ResizeObserver(() => recalcActiveWidthPx(wrap));
    ro.observe(wrap);
    window.addEventListener('orientationchange', () => recalcActiveWidthPx(wrap));
    window.addEventListener('resize', () => recalcActiveWidthPx(wrap));

    // Observa DOM dinâmico dentro do root
    const mo = new MutationObserver(() => recalcActiveWidthPx(wrap));
    mo.observe(wrap, { childList: true, subtree: true });

    // Guarda refs pra limpar se precisar
    root.__cvImgAccRO = ro;
    root.__cvImgAccMO = mo;
  }

  function boot() {
    document.querySelectorAll('.cv-imgacc-wrap').forEach(init);
    if (DEBUG) log('boot OK');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  } else {
    boot();
  }

  function init(root) {
    if (!root || root.__cvImgAcc) return;
    root.__cvImgAcc = true;

    const wrap = root.querySelector('.cv-imgacc');
    if (!wrap) return;

    const isMobile = window.matchMedia('(max-width: 720px)').matches;
    if (isMobile) root.classList.add('is-vertical');

    const mode = isMobile ? 'click' : (root.getAttribute('data-mode') || 'hover');
    const initial = parseInt(root.getAttribute('data-initial') || '0', 10) || 0;
    const items = Array.from(wrap.querySelectorAll('.cv-imgacc__item'));
    if (!items.length) return;

    setActiveFor(items, initial);
    recalcActiveWidthPx(wrap);

    // Interação
    items.forEach((el, idx) => {
      if (mode === 'hover' && !isMobile) {
        el.addEventListener('mouseenter', () => setActiveFor(items, idx));
        el.addEventListener('touchstart', () => setActiveFor(items, idx), { passive: true });
      } else {
        el.setAttribute('tabindex', '0');
        el.addEventListener('click', () => setActiveFor(items, idx));
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setActiveFor(items, idx);
          }
        });
      }
    });

    // Recalcula ao redimensionar
    const ro = new ResizeObserver(() => recalcActiveWidthPx(wrap));
    ro.observe(wrap);
  }



})();
